module.exports = __webpack_public_path__ + "img/img23.43846432.svg";